import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {IssueType} from './issue-type'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {buildItemPickerSearchUrl} from '@github-ui/item-picker-base/api/urls'
import {SearchIssueTypes} from '@github-ui/server-persisted-queries'

/**
 * The types here align with the query made on the server.
 * If the shape of that response changes, this type should be
 * updated to reflect any modified fields
 *
 * NOTE: We use repository.issueTypes instead of organization.issueTypes
 * to ensure proper access control for outside collaborators.
 */

export type GetSearchIssueTypesRequest = {
  owner: string
  repo: string
  query?: string
  count?: number
}

type GetSearchIssueTypesResponseData = {
  repository: {
    issueTypes: {
      edges: Array<{node: IssueType}>
    }
  }
}

export type GetSearchIssueTypesResponse = GraphQLResponse<GetSearchIssueTypesResponseData>

export async function apiGetSearchIssueTypes({
  owner,
  repo,
  query,
  count,
}: GetSearchIssueTypesRequest): Promise<GetSearchIssueTypesResponse> {
  const params: Record<string, unknown> = {owner, repo, queryId: SearchIssueTypes}

  if (query) {
    params['query'] = query
  }

  if (count) {
    params['count'] = count
  }

  const requestUrl = buildItemPickerSearchUrl('issue_types', params)
  const request = await verifiedFetchJSON(requestUrl)
  return (await request.json()) as GetSearchIssueTypesResponse
}

const itemPickerQueryKeyBase = 'item_picker'

export function buildItemPickerIssueTypeSearchQueryKey(searchParams: GetSearchIssueTypesRequest) {
  return [itemPickerQueryKeyBase, 'issue_types', searchParams]
}

export type IssueTypePickerQueryData = {
  issueTypes: IssueType[]
}

export function transformSearchIssueTypeResponseToQueryData(
  response: GetSearchIssueTypesResponseData,
): IssueTypePickerQueryData {
  return {
    issueTypes: response.repository.issueTypes.edges.map(e => e.node),
  }
}
